import { stateMap } from '../constants/states/all';
import { ProductBuilderMachineContext } from '../types';
import { getBreakdown } from './getBreakdown';

type ProductPropertySummary = (
  context: ProductBuilderMachineContext,
) => string[];

export const productPropertySummary: ProductPropertySummary = context => {
  const breakdown = getBreakdown(context);
  return Object.fromEntries(
    breakdown.map(([key, value]) => [[stateMap[key]], value]),
  );
};
